import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {
    useCallback,
} from 'react';

import {
    COLORS,
} from '../../../constants/theme';
import { getFormattedTime } from '../../../utils/date';

import Loader from '../Loader';

import styles from './Events.scss';

const Events = ({ events, isLoading }) => {
    const TODAY = new Date().setHours(0, 0, 0);

    const formatDate = useCallback((event) => {
        const dateFormatter = new Intl.DateTimeFormat(undefined, {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        });

        const toFormattedDate = (date) => dateFormatter.format(new Date(date));

        // Format the date part, which is in UTC
        let formattedDateString = toFormattedDate(event.event_date);
        if (!event.all_day) {
            formattedDateString = `${formattedDateString} from ${getFormattedTime(event.event_date, event.start_time)} until ${getFormattedTime(event.event_date, event.end_time)}`;
        }
        return formattedDateString;
    }, []);

    return (
        <>
            {isLoading && <Loader color={COLORS.secondary} />}
            {!isLoading && (
                <>
                    <h2 className={styles.header}>
                        Events
                    </h2>
                    {
                        events
                            .filter((event) => !event.deleted_at && new Date(event.event_date) >= TODAY)
                            .map((event) => (
                                <div key={event.id} className={classNames(styles.eventContainer, 'border-section')}>
                                    <div className={styles.eventTitle}>{event.title}</div>
                                    <div className={styles.eventDate}>{formatDate(event)}</div>
                                    <div>
                                        {event.description}
                                    </div>
                                </div>
                            ))
                    }
                </>
            )}
        </>
    );
};

Events.propTypes = {
    events: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        description: PropTypes.string,
        event_date: PropTypes.string,
        start_time: PropTypes.string,
        end_time: PropTypes.string,
        all_day: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
        created_at: PropTypes.string,
        updated_at: PropTypes.string,
        deleted_at: PropTypes.string,
    })).isRequired,
    isLoading: PropTypes.bool.isRequired,
};

export default Events;
